import { Component, OnInit } from '@angular/core';
import { CorporateService } from '../corporate-service/corporate-service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-corporate-cancel-reason-list',
  templateUrl: './corporate-cancel-reason-list.component.html',
  styleUrls: ['./corporate-cancel-reason-list.component.css']
})
export class CorporateCancelReasonListComponent implements OnInit {

 mappers: any = [];
 finalMapper = [];
 fundingSources :any= [];
 fundingSourceName= []
 search;
   constructor(private corporateService: CorporateService) { }

   ngOnInit() {
     this.getFundingSource();
   }




   getFundingSource() {
     this.corporateService
       .getCorporateUsers('active')
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe(data => {
         if (data) {
           this.fundingSources = data;
           this.fundingSourceName = data.reduce((obj, item) => (obj[item._id] = item, obj), {})

         }
         this.getReasons();

       });

   }

   getReasons(){
     this.corporateService
       .getChangeReason()
       .pipe(takeUntil(componentDestroyed(this)))
       .subscribe((data) => {
         if (data) {
           this.mappers = data;
         }
       });
   }

   ngOnDestroy(): void {
   }

}
